<template>
  <v-card class="pa-4">
    <h3>{{ $t('mfa_entry.title') }}</h3>
    <div>{{ $t('mfa_entry.label') }}</div>
    <v-otp-input v-model="mfaCode" @paste="trimPasteValue" type="number"/>
    <v-btn color="primary" :disabled="mfaCode.length != 6" @click="login()">{{ $t('mfa_entry.btntext') }}</v-btn>
  </v-card>
</template>

<script>
export default {
  name: "MFAEntry",
  data() {
    return {
      mfaCode: ""
    }
  },
  methods: {
    login() {
      this.$emit('login', this.mfaCode);
    },
    trimPasteValue(event) {
      let paste_text = event.clipboardData.getData("text");
      let trimmed_text = paste_text.trim();
      let isnum = /^\d+$/.test(trimmed_text);
      if (trimmed_text.length == 6 && isnum) {
        this.mfaCode = trimmed_text;
        event.preventDefault();
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/login/MFAEntry.vue